import React from "react";
import HomePageComponent from "../../components/HomePageComponent";
import PropTypes from "prop-types";

const HomePageContainer = (props) => {
  return <HomePageComponent {...props} />;
};

export default HomePageContainer;

HomePageContainer.propTypes = {
  props: PropTypes.any,
};
